import cn from "classnames";

export const BlueGradientDivider = ({
  className,
}: BlueGradientDividerProps) => {
  return (
    <hr
      className={cn(
        "from-secondary to-primary bg-greyscale-background h-1 w-full shrink-0 bg-gradient-to-r",
        className,
      )}
    />
  );
};

export type BlueGradientDividerProps = {
  className?: string;
};
